import { IonProgressBar, IonText } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { type ChosenCoreValueItem } from "@/lib/backend/api";
import { CoreValueRankingRow } from "./RankingRow";

export function PersonalizeStatusCard({
	coreValues,
	onClick,
}: {
	coreValues: ChosenCoreValueItem[];
	onClick?: (coreValue: ChosenCoreValueItem) => void;
}) {
	const { t } = useTranslation();

	const current = coreValues.filter((coreValue) => coreValue.customName).length;
	const target = coreValues.length;

	return (
		<div className="bg-brown-100 flex flex-col gap-2 rounded-2xl p-3">
			<div className="flex flex-col">
				<IonText className="text-brown-700 leading-5 font-bold">
					{t("core-values.personalize.title")}
				</IonText>
				<IonText className="text-brown-700 text-sm leading-5">
					{t("core-values.personalize.count", {
						current,
						target,
					})}
				</IonText>
				<div className="relative isolate flex h-5 w-full items-center">
					<IonProgressBar
						aria-label={t("core-values.personalize.count", {
							current,
							target,
						})}
						value={(current ?? 0) / (target ?? 1)}
						className="!ion-bg-brown-200 h-2"
					/>
					<div
						aria-checked={current === target}
						className="bg-brown-200 absolute inset-y-0 right-0 z-10 grid size-5 place-content-center rounded-full text-transparent aria-checked:bg-orange-500 aria-checked:text-white"
					/>
				</div>
			</div>

			<ol className="flex flex-col gap-3">
				{coreValues.map((coreValue, index) => (
					<CoreValueRankingRow
						key={coreValue.id}
						data-attr="page.app.core-values.ranking-row"
						data={{
							...coreValue.coreValue,
							customName: coreValue.customName,
							number: index + 1,
							type: "compiled",
						}}
						transition={{ duration: 0.2, delay: 0.19 * index }}
						className="bg-brown-200 cursor-pointer"
						onClick={() => onClick?.(coreValue)}
					/>
				))}
			</ol>
		</div>
	);
}
